module.exports = __webpack_public_path__ + "img/DO Pending.592d0fb1.png";